/**
 * @fileoverview Connect calendar draft validation to explicit save, cancel, and duplicate-event review. Redux owns editable fields and the enclosing workspace supplies event persistence callbacks. `6_EventsTableDialog.js` presents existing-event context; opening it does not choose or mutate an event until an explicit action.
 */

import { useSelector, useDispatch } from 'react-redux';
import api from '../../api';
import axios from 'axios';
import React, { useState, useContext, useEffect, useRef } from "react";
import {
  setClientName,
  setMatterNumber,
  setMatterNumbers,
  setMatters,
  setTitle,
  setTitle2,
  setStartDateTime12h,
  setEndDateTime12h,
  setSelectedCategory,
  setAllday,
  setDate,
  setDaterange,
  setNotes,
  setFileIds,
  setCreateTask,
  setSelectedTrelloMember,
  setDaysBeforeDeadline,
  setCurrentlyEditingEvent,
  setTimeZone,
  setUploadedFiles,
  setSelectedFiles,
  setEventsTableVisible,
  setLocation,
  setTrelloCardTitle,
  setAssignedAttorneys } from
'../../store/CalendarInput/action';
import moment, { max, min } from 'moment-timezone';
import Button from "../shared/AppPrimeButton";
import ToastContext from '../../ToastContext';

const categories = [
{ name: 'Our Deadline', color: 'red', colorId: 11 },
{ name: 'Opponent Deadline', color: 'green', colorId: 10 },
{ name: 'Court/Arbitrator Deadline', color: 'purple', colorId: 3 },
{ name: 'Our Appearance Required', color: 'yellow', colorId: 5 },
{ name: 'Anything Else', color: 'blue', colorId: 9 }];


const timeZones = [
{
  label: "Pacific Time",
  value: "America/Los_Angeles"
},
{
  label: "Mountain Time",
  value: "America/Denver"
},
{
  label: "Central Time",
  value: "America/Chicago"
},
{
  label: "Eastern Time",
  value: "America/New_York"
}];




const Actions = ({ onSave, onClose, isLoading }) => {
  const dispatch = useDispatch();
  const showToast = useContext(ToastContext);

  const currentlyEditingEvent = useSelector((state) => state.calendarInput.currentlyEditingEvent);

  return (
    <>
            <Button
        label={`${currentlyEditingEvent ? 'Update' : 'Create'} Calendar Entry`}
        icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-Calendar"}
        className="w-auto"
        onClick={onSave}
        severity={`${currentlyEditingEvent ? 'help' : 'primary'}`}
        disabled={isLoading}
        loading={isLoading} />

            <Button
        label="Cancel"
        icon="pi pi-times"
        className="w-auto ml-3"
        onClick={onClose}
        outlined
        disabled={isLoading} />

            <Button
        label="Show Created Events"
        className="w-auto ml-3"
        size="small"
        outlined
        severity="help"
        onClick={() => dispatch(setEventsTableVisible(true))}
        disabled={isLoading} />

        </>);

};

export default Actions;
